import React from "react";

const PrescriptionView = ({ data }) => {
    if (!data) return null;

    const { patientDetails, patientHistory, pastVitalReadings, diabetesDiseaseDiagnosis, hypertensionDiseaseDiagnosis } = data;

    if (!pastVitalReadings || Object.keys(pastVitalReadings).length === 0) {
        return <div className="container mt-3"><p>No vital readings available</p></div>;
    }

    const lastDate = Object.keys(pastVitalReadings)[0];
    const lastVitals = pastVitalReadings[lastDate];

    const sugar = lastVitals.find(v => v.sugarVitals)?.sugarVitals?.rndBldGlc || "-";
    const bp = lastVitals.find(v => v.bpVitals)?.bpVitals || null;

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        }).replace(',', '-');
    };

    return (
        <div className="container mt-3">
            <h4 className="text-center">Current Status and Prescription</h4>
            <p className="text-end">Printed on : {formatDate(new Date())}</p>

            <h5>{patientDetails.name}</h5>
            <p>{patientDetails.age} Years | {patientDetails.gender}</p>

            <p><strong>History:</strong> {patientHistory.join(" | ")}</p>

            {/* past readings */}
            <div className="table-responsive">
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>RBS (mg/dl)</th>
                        <th>BP(mmHg)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{lastDate}</td>
                        <td>{sugar}</td>
                        <td>{bp ? `${bp.sys}/${bp.diast}` : "-"}</td>
                    </tr>
                </tbody>
            </table>

            {/* Diabetes */}
            <h5 className="mt-4">Diabetes Section</h5>
            <p><b>Diagnosis:</b> {diabetesDiseaseDiagnosis.diagnosisRslt}</p>
            <p><b>Next Visit:</b> {diabetesDiseaseDiagnosis.nextVisitDateStr}</p>
            <p><b>Referred To:</b> {diabetesDiseaseDiagnosis.referredTo}</p>

            {/* Hypertension */}
            <h5 className="mt-4">Hypertension Section</h5>
            <p><b>Diagnosis:</b> {hypertensionDiseaseDiagnosis.diagnosisRslt}</p>
            <div className="table-responsive">
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th>Medicine</th>
                        <th>Frequency</th>
                        <th>Duration</th>
                        <th>Qty</th>
                        <th>Instruction</th>
                    </tr>
                </thead>

                <tbody>
                    {hypertensionDiseaseDiagnosis.medicationAdvice?.map((m, i) =>
                        <tr key={i}>
                            <td>{m.name}</td>
                            <td>{m.freq}</td>
                            <td>{m.dur}</td>
                            <td>{m.quan}</td>
                            <td>{m.spInst}</td>
                        </tr>
                    )}
                </tbody>
            </table>
            </div>
           </div>
            <p><b>Next Visit:</b> {hypertensionDiseaseDiagnosis.nextVisitDateStr}</p>
            <p><b>Referred To:</b> {hypertensionDiseaseDiagnosis.referredTo}</p>

            <br /> <br />
            <p>Doctor’s Name & Signature</p>

        </div>
    );
};

export default PrescriptionView;
